import {getPlatformInstance} from "@/platforms"
import {debounce} from "lodash-es";
import {Dialog, Toast} from "vant";
import QS from "qs";

/**
 * 项目Url
 * @returns {string}
 */
export const baseURL = /^(.+[^\/])\/+webapp\//.exec(location.href)[1];

/**
 * 获取url参数
 * @param key
 * @returns {string}
 */
export const getQuery = key => {
    let result
    const sessionStoragePrefix = 'url-query-'
    // 先从url里取值
    let reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)", "i")
    let query = window.location.search;
    let resIndex = 2;
    if(query === ""){
        query = window.location.hash;
        reg = new RegExp(key + "=([^&]*)(&|$)", "i")
        resIndex = 1;
    }
    if(!query || query === "" || query.indexOf("?")===-1 || query.indexOf("=")===-1){
        query = window.location.href;
    }
    const r = query.substr(1).match(reg)
    if (r && r.length > 2) {
        result = r[resIndex]
        sessionStorage.setItem(sessionStoragePrefix + key, result)
    } else {
        result = sessionStorage.getItem(sessionStoragePrefix + key)
    }
    return result
}
/**
 * 添加url参数
 * @param url
 * @param name
 * @param value
 * @returns {string|*}
 */
export const addQuery = (url, name, value) => {
    if (!url) return url
    const [href,path=""] = url.split("#")
    const [urlPath,querystr = ""] = href.indexOf('?')?href.split('?'):[href];
    const query = QS.parse(querystr)
    query[name] = value
    return `${urlPath}?${QS.stringify({...query})}${path?"#"+path:""}`;
}
/**
 * 给url添加时间戳
 * @param url
 * @returns {string|*}
 */
export const bust = url => addQuery(url, '_', new Date().getTime());
/**
 * 补全url
 * @param url
 * @param nonlogin
 * @returns {string|*}
 */
export const complete = (url, nonlogin=false) => {
    if (!url || typeof url != 'string') return url
    if (url.startsWith('data:')) return url
    // 去除两端空格
    url = url.trim()
    // 兼容weui开头的相对地址
    if (url.startsWith('weui/')) return baseURL + '/weixin/' + url
    // 兼容weixin开头的相对地址
    if (url.startsWith('weixin/')) return baseURL +'/'+url
    // 兼容extensionapp开头的相对地址（多渠道认证跳转）
    if (url.startsWith('extensionapp/')) return baseURL +'/'+url
    // 兼容URLPATH为0的相对路径
    if (url.startsWith('/') && !url.startsWith('/weixin') && !url.startsWith('/webapp')) return url
    if (!url.startsWith('http')) return baseURL + (nonlogin ? '/nonlogin/' : '/') + url
    return url
}

/**
 * 重定向
 * @param url
 * @returns {boolean}
 */
export const locationTo = (url) => {
    if (!url || typeof url != 'string' || url === 'NO' || url === 'null') {
        Toast('移动端暂不支持此业务，请到PC端办理')
        return false;
    }
    url = url.trim()
    url = complete(url)
    if (!url.includes('webapp/index.html')) url = bust(url)
    getPlatformInstance().then((platform) => {platform.navigate(url)});
}